import '../card.scss';
import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import ButtonSecondary from '@components/atoms/buttons/ButtonSecondary';

const CardContent = ({
	modifiers,
	className,
	link,
	image,
	alt = '',
	title,
	text,
	...otherProps
}) => {
	const baseClass = 'card-content';
	const variantClass = 'card-content--link';
	const defaultClass = 'card';

	const rootClass = cx(
		baseClass,
		className,
		defaultClass,
		{
			[`${baseClass}--${modifiers}`]: modifiers,
		},
		link && variantClass
	);

	return (
		<div
			className={rootClass}
			data-card
			data-target={link ? true : false}
			{...otherProps}
		>
			<div className="card__inner">
				<figure className="card__thumbnail" aria-label={title}>
					<img src={image} alt={alt} loading="lazy" />
				</figure>
				<div className="card__info">
					<h3 className="card__title">{title}</h3>
					<p className="card__text">{text}</p>
					{link && (
						<ButtonSecondary href={link.url} text={link.title} />
					)}
				</div>
			</div>
			<span className="card__background"></span>
			<span className="card__shadow"></span>
		</div>
	);
};

CardContent.propTypes = {
	modifiers: PropTypes.string,
	className: PropTypes.string,
	link: PropTypes.object,
	image: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default CardContent;
